"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.707 7.56a6.144 6.144 0 1 0-12.288 0 6.144 6.144 0 0 0 12.288 0m.423 0a6.565 6.565 0 0 1-6.356 6.56v4.725h3.69a.212.212 0 0 1 0 .423h-3.69v3.512a.212.212 0 0 1-.423 0v-3.512H7.66a.212.212 0 1 1 0-.423h3.69V14.12A6.565 6.565 0 0 1 11.562.992 6.57 6.57 0 0 1 18.13 7.56"
}), 'WomensHealth');
